/* Global outline color override - uses Colors.bubbleColor (#3f7b8d) */
* {
  outline-color: #3f7b8d !important;
}

*:focus {
  outline-color: #3f7b8d !important;
}

html,
body,
#root {
  overscroll-behavior-x: none;
}

input:focus,
textarea:focus,
select:focus,
button:focus {
  outline-color: #3f7b8d !important;
}

/* Exercise notes textarea placeholder color */
.exercise-notes-textarea::placeholder {
  color: #9c9c9cff;
  opacity: 1;
}

/* Inline protocol textarea placeholder color */
.inline-protocol-textarea::placeholder {
  color: #9c9c9cff;
  opacity: 1;
}

/* Rounded focus ring for serie target pills only */
.serie-pill-input {
  outline: none !important;
  box-shadow: none !important;
  border-radius: 9999px !important;
}

.serie-pill-input:focus,
.serie-pill-input:focus-visible {
  outline: none !important;
  box-shadow: 0 0 0 2px #3f7b8d !important;
  border-radius: 9999px !important;
}
